<template>
  <div
    class="modal fade"
    id="msgAfterBought"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLongTitle"
    aria-hidden="true"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
      <div class="modal-content text-center" v-if="status == 0">
        <div class="modal-header bg-light border-0">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="close()"
          >
            <i class="pz-icon icon-close"></i>
          </button>
        </div>
        <div class="modal-header bg-light mt-n5">
          <div class="modal-title">
            <h3>还差一步！</h3>
            <p>
              就可以进入班级，与学员交流啦！如遇进班问题请联系技术客服，
              微信号：pzacademy-tech
            </p>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-6">
              <h5>我是新学员</h5>
              <img
                src="https://resources.pzacademy.com/image/qrcode/qrcode-qiyehao.jpg"
                height="150px"
                width="150px"
                class="mb-3 img-thumbnail"
              />
              <!-- <p>
                请扫二维码进入企业号，
                <br />静待入群哦！
              </p> -->
              <p  class="small text-left">
第一步：请扫二维码进入企业号！<br>
第二步：点击链接http://pzhelper.mikecrm.com/piBT11R按照进班流程图操作进班！</p>
            </div>
            <div class="col-6">
              <h5>我是老学员</h5>
              <a
                class="btn btn-outline-secondary border mx-auto d-flex flex-column align-items-center justify-content-center mb-3"
                style="width: 150px; height: 150px"
                href="http://pzhelper.mikecrm.com/piBT11R"
                target="_blank"
              >

                <img
                  src="https://resources.pzacademy.com/image/class-ui/106.svg"
                  height="80px"
                  width="80px"
                  class="mb-2"
                />
                <span class="blue-700">进班流程图</span>
              </a>
              <p class="small text-left px-3">
                请直接点击链接按照进班流程图操作进班。
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" @click="dontJoin()" class="btn-light btn-lg" data-dismiss="modal">
            我放弃入班
          </button>
          <button type="button" @click="action(1)" class="btn-info btn-lg">我已经完成</button>
        </div>
      </div>

      <div class="modal-content text-center" v-if="status == 1">
        <div class="modal-body p-5">
          <h3 class="m-b-30">你确定要放弃加入班级</h3>
          <p>
            如日后想再次加入班级，请到【
            <a
              :href="`https://class.${SERVER_ROOT_DOMAIN}/api/students/mustread.html#B`"
              target="_blank"
              >学员必读</a
            >】里查看如何加班班级。
          </p>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" @click="action(-1)" class="btn-info btn-lg">确定</button>
          <button type="button" @click="cancel()" class="btn-light btn-lg">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';

import { SERVER_ROOT_DOMAIN } from '@/constants/index';

import { actionImportantMessage } from '../global/service';

export default {
  name: 'MsgAfterBought',
  props: {
    messageId: Number,
  },

  data: () => ({
    SERVER_ROOT_DOMAIN,
    status: 0,
  }),

  methods: {
    dontJoin() {
      this.status = 1;
    },

    action(status) {
      $(`#msgAfterBought`).modal('hide');
      actionImportantMessage({
        messageId: this.messageId,
        action: status,
      });
    },

    cancel() {
      this.status = 0;
    },

    close() {
      $(`#msgAfterBought`).modal('hide');
    },
  },
};
</script>
<style scoped lang="scss"></style>
